"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// Import Table Styles
const TableHeader_styles_1 = require("./TableHeader.styles");
// Import Components
const Icon_1 = require("../Icon/Icon");
const Tooltip_1 = require("../Tooltip/Tooltip");
const StyledTableHeader = ({ columns, sortColumn, sortedColumnIndex, sortDirection, isStatic, }) => {
    const handleColumnClick = (columnIndex) => {
        const direction = sortedColumnIndex !== columnIndex
            ? 'desc'
            : sortDirection === 'desc'
                ? 'asc'
                : 'desc';
        sortColumn === null || sortColumn === void 0 ? void 0 : sortColumn(columnIndex, direction);
    };
    return (react_1.default.createElement(TableHeader_styles_1.StyledTableHeaderContainer, { isStatic: isStatic }, columns.map((column, index) => {
        var _a;
        return (react_1.default.createElement(TableHeader_styles_1.StyledTableHeaderColumn, { key: index, width: column.width },
            react_1.default.createElement(Tooltip_1.Tooltip, { key: `TableHeaderColumnLabel${index}_tooltip`, title: (_a = column.toolTipText) !== null && _a !== void 0 ? _a : '', placement: 'top', style: {
                    display: column.toolTipText ? 'inline-block' : 'none',
                } },
                react_1.default.createElement(TableHeader_styles_1.StyledTableHeaderColumnLabel, { isStatic: isStatic, columnIndex: index, alignment: column.alignment, isSortable: column.isSortable, sortedColumnIndex: sortedColumnIndex, onClick: () => column.isSortable && handleColumnClick(index) },
                    column.toolTipText && (react_1.default.createElement(TableHeader_styles_1.StyledTableHeaderColumnLabelTooltipIcon, null,
                        react_1.default.createElement(Icon_1.Icon, { key: `TableHeaderColumnLabel${index}_tooltip_icon`, size: '14', "data-testid": `TableHeaderColumnLabel${index}_tooltip_icon`, color: index === sortedColumnIndex ? 'blue' : 'gray2', icon: 'stationNote' }))),
                    column.label,
                    column.isSortable && (react_1.default.createElement(TableHeader_styles_1.StyledTableHeaderColumnLabelArrowIcon, { isActive: Boolean(sortedColumnIndex === index), sortDirection: sortDirection, id: `arrow_icon_container_${index}` },
                        react_1.default.createElement(Icon_1.Icon, { key: `TableHeaderColumnLabel${index}_arrow_icon`, size: '10', "data-testid": `TableHeaderColumnLabel${index}_arrow_icon`, color: index === sortedColumnIndex ? 'blue' : 'gray', icon: 'arrowDown' })))))));
    })));
};
exports.default = StyledTableHeader;
//# sourceMappingURL=TableHeader.js.map